// Please note that to enable features or switches they must
// also be added to features.yml in the checkout code base
export const DISABLED_FEATURE = {
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  KLARNA: 'klarna',
  LINK_PAY: 'link_pay',
  PAYPAL: 'paypal',
  THRESHOLD_BAR: 'threshold_bar',
  YOTI: 'yoti',
};

export default {
  APPLE_PAY_WITHOUT_SAVED_CARD: 'apple_pay_without_saved_card',
  CAMPAIGN_BANNER: 'campaign_banner',
  CONFIRMATION_EMAIL_DELAY: 'confirmation_email_delay',
  CONCISE_CARD_SECURITY_MESSAGE: 'concise_card_security_message',
  DISABLE_FEATURE: 'disable_feature',
  DISABLE_APPLE_PAY_EXPRESS: 'disable_apple_pay_express',
  EMERGENCY_DELIVERY_PAGE_MESSAGE: 'emergency_delivery_page_message',
  EMERGENCY_PAYMENT_PAGE_MESSAGE: 'emergency_payment_page_message',
  EMERGENCY_ORDER_CONFIRMATION_MESSAGE: 'emergency_order_confirmation_message',
  ENABLE_PAYPAL_EXPRESS: 'enable_paypal_express',
  EXPERIMENT_MANAGED_IMPRESSIONS: 'experiment_managed_impressions',
  FORCE_CUSTOMER_APP_TYPE: 'force_customer_app_type',
  LOG_ANALYTICS: 'logAnalytics',
  LOWER_ATRA_THRESHOLD_FOR_GUESTS_TO_220: 'lower_atra_threshold_for_guests_to_220',
  MEMBERS_WEEK_MESSAGING: 'members_week_messaging',
  MULTIPLE_PROMO_CODE_ATTEMPT: 'multiple_promo_code_attempt',
  NO_MARKETING: 'no_marketing',
  PAYPAL_CLIENT_TOKEN_OVERRIDE: 'payPalClientTokenOverride',
  RAVELINJS_DISABLED: 'ravelinjs_disabled',
  REDUCE_SAVED_CARD_CVV_SKIP: 'reduce_saved_card_cvv_skip',
  SHOW_CALL_CENTRE_NUMBER_ON_3DS_ERROR: 'show_call_centre_number_on_3ds_error',
  SHOW_RECOMMENDATIONS: 'show_recommendations',
  SINGLE_PAGE_CHECKOUT_ENABLED: 'single_page_checkout_enabled',
  STREAMLINED_DELIVERY_METHOD: 'streamlined_delivery_method',
  STRIPE_KLARNA_CHECKOUT_ENABLED: 'stripe_klarna_checkout_enabled',
  STRIPE_LINK_CHECKOUT_ENABLED: 'stripe_link_checkout_enabled',
  STRIPE_SAVED_CARDS_ENABLED: 'stripe_saved_cards_enabled',
  TRA_EXTRA_VISA: 'tra_extra_visa',
  TRA_VISA_BINS: 'tra_visa_bins',
  USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE: 'use_local_paypal_sandbox_override',
  USE_REAL_KLARNA: 'use_real_klarna',
  USE_REAL_LOQATE_OVERRIDE: 'use_real_loqate_override',
  USE_STUBBED_NEWRELIC: 'use_stubbed_newrelic',
};
